import { createAction, props } from '@ngrx/store';
import { Auditoria, AuditoriaForm } from '@core/models'
import { ResponseBadRequest } from '@core/interfaces';

export const AUDIT_FIND = createAction('[Audit] Find', props<{ id: string }>());
export const AUDIT_FIND_ALL = createAction('[Audit] Find All');

export const AUDIT_FIND_SUCCESS = createAction('[Audit] Find Success', props<{ audit: Auditoria }>());
export const AUDIT_FIND_ALL_SUCCESS = createAction('[Audit] Find All Success', props<{ auditList: Auditoria[] }>());

export const AUDIT_FAILURE = createAction('[Audit] Failure', props<{ error: ResponseBadRequest }>());

export const AUDIT_UPDATE_LOADING = createAction('[Audit] Update Loading', props<{ loading: boolean }>());
export const AUDIT_UPDATE_FORM = createAction('[Audit] Update Form', props<{ auditForm: AuditoriaForm }>());
export const AUDIT_UPDATE_FORM_VALID = createAction('[Audit] Update Form Valid', props<{ formValid: boolean }>());
export const AUDIT_UPDATE_INMUTABLE = createAction('[Audit] Update Inmutable', props<{ inmutable: boolean }>());
export const AUDIT_EDIT_MODE = createAction('[Audit] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const AUDIT_UPDATE_ID = createAction('[Audit] Update Id', props<{ auditId: string|null }>());

export const AUDIT_CREATE_VIEW = createAction('[Audit] Create View');
export const AUDIT_UPDATE_VIEW = createAction('[Audit] Update View', props<{ auditId: string }>());

export const AUDIT_CREATE = createAction('[Audit] Create');
export const AUDIT_UPDATE = createAction('[Audit] Update');
export const AUDIT_UPDATE_ENABLED = createAction('[Audit] Update Enabled', props<{ id: string, auditForm: AuditoriaForm }>());
export const AUDIT_REMOVE = createAction('[Audit] Remove', props<{ id: string }>());

export const AUDIT_CREATE_COMPLETED = createAction('[Audit] Create Completed');
export const AUDIT_UPDATE_COMPLETED = createAction('[Audit] Update Completed');
export const AUDIT_REMOVE_COMPLETED = createAction('[Audit] Remove Completed');

export const AUDIT_RESET = createAction('[Audit] Reset');
export const AUDIT_RESET_FORM = createAction('[Audit] Reset Form');
export const AUDIT_RESET_ERROR = createAction('[Audit] Reset Error');
export const AUDIT_CLEAR_STATE = createAction('[Audit] Clear State');